  <ng-container *ngTemplateOutlet="productMaskingContainer"></ng-container>
  <div class="new-hcf-card" [ngClass]="{ 'custom-container-shadow': callingfrom === 'viewAllDoc' }">
    <div
    (click)="$event.preventDefault();$event.stopPropagation(); templateInfo.card_target ? cardTarget(templateInfo.card_target): null" class="position-relative hcf-card-wrapper" [ngClass]="{'template-1': template === templateConstant.ONE, 'template-2': template === templateConstant.TWO, 'template-3': template === templateConstant.THREE, 'template-4': template === templateConstant.FOUR, 'cursor-pointer': templateInfo.card_target, 'd-flex': template === templateConstant.FOUR && productCount === number.ONE }">
    <div *ngIf="templateInfo.banner" class="carousel-banner">
       <img loading="lazy" class="rounded-img-top post-pic" [src]="templateInfo.banner" alt="banner" onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" [ngClass]="{'video-thumbNail rounded': template === templateConstant.FOUR,'contiueWatchList': viewAll === true }">
    <div *ngIf="template === templateConstant.FOUR">
      <img class="position-absolute toast-center-center play-icon" [src]="'assets/themes/icons/play-icon.svg'" alt='play'>
      <div class="position-absolute text-white primary-small pl-1 pr-1 timer-doctalk rounded">
        <p>{{playTime}}</p>
      </div>
      <div class="position-absolute bg-danger video-paused-doctalk" [ngStyle]="{'width': width}"></div>
    </div>
    </div>
    <div *ngIf="!templateInfo.banner && template === templateConstant.FOUR " class="carousel-banner">
      <img class="img-radius video-thumbNail" src="assets/themes/images/banner-placeholder-lg.svg" alt="banner" />
      <div>
        <img class="position-absolute toast-center-center play-icon" [src]="'assets/themes/icons/play-icon.svg'" alt='play'>
        <div class="position-absolute text-white fnt-size12px pl-1 pr-1 timer-doctalk rounded">
          <p>{{playTime}}</p>
        </div>
        <div class="position-absolute bg-danger video-paused-doctalk" [ngStyle]="{'width': width}"></div>
      </div>
   </div>
    <div class="carousel-banner-profile justify-content-center">
      <img class="rounded-circle user-100" [ngClass]="{'post-pic':templateInfo.banner}" [src]="templateInfo.banner" onError="this.src='assets/themes/icons/user-profile-placeholder.svg';" alt="pic"/>
    </div>
    <div class="px-2 pt-2 pb-3 carousel-content" [ngStyle]="template === templateConstant.THREE && {'background-image': 'url(' + templateInfo?.banner + '), url(assets/images/grandround/image_placeholder.svg)'}">
    <div>
      <p *ngIf="templateInfo.title" class="carousel-heading description-line-2 paragraph-bold t3-color">
        {{templateInfo.title}}
      </p>
      <div>
        <p *ngIf="templateInfo.subtitle" class="carousel-sub-heading-tags primary-small pt-2 description-line-2">
          <span class="color-grey-500">{{templateInfo.subtitle}}</span>
        </p>
        <p *ngIf="templateInfo.creator" class="d-flex align-items-center carousel-sub-heading primary-small description-line-2">
          <span class="badge-icon mr-1" *ngIf="templateInfo.creator?.image">
            <img loading="lazy" class="img-height" [src]="templateInfo.creator?.image" alt="powered" onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'">
          </span>
          <span class="color-grey-500 pr-1">
            {{templateInfo.creator?.label}}
          </span>
          <span class="color-grey-700">
            {{templateInfo.creator?.name}}
          </span>
        </p>
      </div>
    </div>
    <div class="carousel-footer d-flex justify-content-end align-items-center">
      <span *ngIf="templateInfo.impression" class="primary-small description-line-1 py-3">
        <span class="color-grey-500">{{templateInfo.impression?.text}}</span>
      </span>
      <button type="button"
        *ngIf="templateInfo.target && templateInfo.target.enabled === templateStatus.ENABLE"
        [disabled]="templateInfo?.target?.disabled"
        [ngClass]="{'outline-disabled': templateInfo?.target?.disabled, 'outline': !templateInfo?.target?.disabled}"
        class="text-truncate btn-design small flex-shrink-0 my-1"
        (click)="$event.preventDefault();$event.stopPropagation();ctaTarget(templateInfo.target)">
        {{buttonLabel}}
      </button>
    </div>
    </div>
    <span *ngIf="templateInfo.badge && templateInfo.badge.enabled === templateStatus.ENABLE" class="carousel-card-badge rounded-border" [ngStyle]="{'background-color' : '#000', color: 'white'}">
      {{templateInfo.badge.text}}
    </span>
    </div>
  </div>
  <ng-template #productMaskingContainer>
    <div class="position-absolute w-100 h-100 masking-div"
      *ngIf="templateInfo?.channel?.content_visibility?.display === contentVisibility.MASKING || templateInfo?.channel?.content_visibility?.display === contentVisibility.SUBMITTED">
      <app-product-masking-card
        [content_visibility]="templateInfo?.channel?.content_visibility">
      </app-product-masking-card>
    </div>
  </ng-template>
